"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactOverlays = require("react-overlays");

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledContainer = _styledComponents.default.div.withConfig({
  displayName: "DropdownContainer__StyledContainer",
  componentId: "design-system__sc-1a4xfvq-0"
})(["display:flex;min-width:150px;position:absolute;flex-direction:column;border:1px solid #e5e5e5;background-color:rgb(255,255,255);box-shadow:rgba(0,0,0,0.1) 0px 0px 5px;border-color:rgb(235,235,235) rgb(235,235,235) rgb(235,235,235);border-width:1px 1px 1px;border-style:none solid solid;border-image:initial;border-top:none;padding:", ";z-index:11;& > span{margin:8px;padding:16px 0 0;text-transform:uppercase;user-select:none;font-size:14px;line-height:1;color:#6f6f6f;border-top:1px solid rgba(111,111,111,.2);}& > a{line-height:1;display:block;padding:8px;color:", ";text-decoration:none;:hover{text-decoration:none;background-color:", ";}}"], _ref => {
  let {
    noPadding
  } = _ref;
  return noPadding ? 0 : '8px';
}, _BaseTheme.default.colors.black, _BaseTheme.default.colors.bluegray);

const DropdownContainer = _ref2 => {
  let {
    children,
    noPadding
  } = _ref2;
  const {
    show,
    props
  } = (0, _reactOverlays.useDropdownMenu)({
    flip: true
  });
  const {
    ref,
    'aria-labelledby': ariaLabelledby,
    style
  } = props;
  if (!show) return null;
  return /*#__PURE__*/_react.default.createElement(StyledContainer, {
    ref: ref,
    "aria-labelledby": ariaLabelledby,
    style: style,
    role: "menu",
    noPadding: noPadding
  }, children);
};

DropdownContainer.propTypes = {
  children: _propTypes.default.node.isRequired,
  ref: _propTypes.default.func,
  style: _propTypes.default.objectOf(_propTypes.default.string),
  'aria-labelledby': _propTypes.default.string,
  noPadding: _propTypes.default.bool
};
DropdownContainer.defaultProps = {
  ref: undefined,
  style: undefined,
  'aria-labelledby': undefined,
  noPadding: false
};
var _default = DropdownContainer;
exports.default = _default;